// src/calculation/generateTables/dataLoad.js

function parseSize(size) {
  if (!size) return [0, 0, 0];

  const parts = size
    .replace(/[\[\]]/g, "")
    .replace(/[xX\*]/g, ",")
    .split(",")
    .map((v) => Number(v.trim()));

  return [
    parts[0] ?? 0, // height
    parts[1] ?? 0, // width
    parts[2] ?? 0 // depth
  ];
}
export function parseTablePositions(str) {
  if (!str) return [];
  return str
    .split("],")
    .map((s) =>
      s
        .replace("[", "")
        .replace("]", "")
        .split(",")
        .map((v) => Number(v.trim()))
    )
    .filter((arr) => arr.length >= 4);
}
/**
 * Backend ekvivalens:
 * Map<Color, List<Rect>> + per-color sort
 */
export function buildAndSortRectsByColor(createdItems, mode, tableIds) {
  const rectsByColor = {};
  let localId = 0;

  for (const it of createdItems) {
    const colorId = it.color?.colorId;
    if (colorId == null) continue; // backendhez igazodva: skip

    const millingId = it.milling?.millingId ?? null; // ha nincs, akkor külön group lesz

    const groupKey = `${colorId}__${millingId ?? "no-milling"}`;
    const effectiveQty =
      it.generateQty != null ? Number(it.generateQty) : Number(it.qty);
    const qty = effectiveQty == null ? 1 : effectiveQty;
    if (qty <= 0) continue;

    const [h0, w0, depth] = parseSize(it.size);

    const width = w0;
    const height = h0;

    const rotable = Boolean(it.rotable) || Boolean(it.color?.rotable);
    if (!rectsByColor[groupKey]) {
      rectsByColor[groupKey] = [];
    }
    if (mode === "lines") {
      const positions = parseTablePositions(it.tablePosition);

      const filteredPositions =
        tableIds.length > 0
          ? positions.filter((position) =>
              tableIds.some(
                (tableId) => String(tableId) === String(position[3])
              )
            )
          : positions;

      for (let i = 0; i < filteredPositions.length; i++) {
        const position = filteredPositions[i];

        const rawDatiRowNumber = Number(position?.[4]);

        rectsByColor[groupKey].push({
          width,
          height,
          depth,

          xpos: position?.[0] ?? 0,
          ypos: position?.[1] ?? 0,
          rotated: position?.[2] === 1,

          tableIndex: position?.[3] ?? 0,
          id: position?.[3],

          // Az ötödik tablePosition mező
          datiRowNumber:
            Number.isInteger(rawDatiRowNumber) && rawDatiRowNumber > 0
              ? rawDatiRowNumber
              : null,

          rotable,
          mainid: it.itemId,
          localid: localId++,
          createdItem: it,
          millingId
        });
      }
    } else {
      for (let i = 0; i < qty; i++) {
        rectsByColor[groupKey].push({
          width,
          height,
          depth,
          xpos: 0,
          ypos: 0,
          rotable,
          mainid: it.itemId,
          localid: localId++,
          millingId: millingId,
          createdItem: it, // ⬅️ EZ A LÉNYEG

          _origW: width,
          _origH: height
        });
      }
    }
  }

  for (const groupKey in rectsByColor) {
    if (mode === "lines") {
      // ===== REPLAY SORREND =====
      rectsByColor[groupKey].sort((a, b) => {
        // 1️⃣ Először oszlop szerint (x)
        if (Math.abs(a.xpos - b.xpos) > 1e-6) {
          return a.xpos - b.xpos;
        }

        // 2️⃣ Utána sor szerint (y)
        return a.ypos - b.ypos;
      });
    } else {
      // ===== OPTIMALIZÁLÓ SORREND =====
      rectsByColor[groupKey].sort((a, b) => {
        const areaA = a._origW * a._origH;
        const areaB = b._origW * b._origH;
        if (areaA !== areaB) return areaB - areaA;
        if (a._origW !== b._origW) return b._origW - a._origW;
        return b._origH - a._origH;
      });
    }

    for (const r of rectsByColor[groupKey]) {
      delete r._origW;
      delete r._origH;
    }
  }

  return rectsByColor;
}
